<script>
    export let type = '';
    export let unstyled = false;
</script>

<style>
    .fa5-cog {
        color: #1B67B1;
    }

    .fa5-medkit {
        color: #F47B2E;
    }

    .fa5-search {
        color: #2FA3D7;
    }

    .fa5-wrench {
        color: #02AB8B;
    }

    .fa5-cube {
        color:#9D2F92;
    }

    .icon {
        font-size: .69rem;
    }

    .unstyled {
        color: #BDBEBC !important;
    }
</style>

<span class="icon" title={type ? type.toLowerCase() : ''}>
    {#if type === "KNACK"}
    <i class="fas fa5-cog {unstyled ? 'unstyled' : ''}"></i>
    {:else if type === "TOOL"}
    <i class="fas fa5-wrench {unstyled ? 'unstyled' : ''}"></i>
    {:else if type === "PART"}
    <i class="fas fa5-cube {unstyled ? 'unstyled' : ''}"></i>
    {:else if type === "QUALITY"}
    <i class="fas fa5-search {unstyled ? 'unstyled' : ''}"></i>
    {:else if type === "SAFETY"}
    <i class="fas fa5-medkit {unstyled ? 'unstyled' : ''}"></i>
    {/if}
</span>

